<app-admin-user-list (selected)="selected($event)" class="list"></app-admin-user-list>
<div class="details">
  <ng-container *ngIf="selectedUser">
    <app-admin-user-details [user]="selectedUser"></app-admin-user-details>
  </ng-container>
</div>
